/*
 * @Author: kian
 * @Date: 2021-11-08 17:39:55
 * @LastEditors: kian
 * @LastEditTime: 2021-11-08 17:39:56
 * @Description:
 */
export const GetAdByType = (type) => {
  return {
    url: `/adapi/ad/web?showType=${type}`,
    method: 'get',
  };
};
